import $ from 'jquery';

class Loader {
	container;
	timer;
	timeout;

	constructor() {
		this.timer = null;
		this.timeout = 8 * 1000;
	}

	show(parentElement) {
		if(this.timer !== null) {
			clearTimeout(this.timer);
		}

		const container = $('<div class="element--loader"><div class="spinner"></div></div>');

		container.css('display', 'flex');

		$(parentElement).append(container);

		this.timer = setTimeout(() => container.remove(), this.timeout);
	}
}

export default function showLoader(target) {
	const loader = new Loader();
	loader.show(target);
}
